import { createContext, useContext } from 'react';
import type { Transaction } from '@/types';

// What a row is in comes with the row (`Transaction.spaceExpenses`, VER-571): the context opens the drawer alone.
export const SendToSpaceContext = createContext<{
  open: (transaction: Transaction) => void;
  openById: (transactionId: string, spaceId?: string) => Promise<void>;
  resolving: boolean;
} | null>(null);

export function useSendToSpace() {
  return useContext(SendToSpaceContext);
}
